var _defs, _line, _line2, _line3, _line4, _line5, _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartiot3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodeGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#60A5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2563EB"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 30,
    x2: 28,
    y2: 62,
    stroke: "#93C5FD",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 30,
    x2: 100,
    y2: 62,
    stroke: "#93C5FD",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 62,
    x2: 64,
    y2: 94,
    stroke: "#93C5FD",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 62,
    x2: 64,
    y2: 94,
    stroke: "#93C5FD",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 62,
    x2: 100,
    y2: 62,
    stroke: "#93C5FD",
    strokeWidth: 3,
    opacity: 0.9
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 16,
    width: 32,
    height: 26,
    rx: 7,
    fill: "url(#nodeGrad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 50,
    width: 32,
    height: 26,
    rx: 7,
    fill: "url(#nodeGrad)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 50,
    width: 32,
    height: 26,
    rx: 7,
    fill: "url(#nodeGrad)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 82,
    width: 32,
    height: 26,
    rx: 7,
    fill: "url(#nodeGrad)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 29,
    r: 3,
    fill: "#FACC15"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 63,
    r: 3,
    fill: "#FACC15"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 63,
    r: 3,
    fill: "#FACC15"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 95,
    r: 3,
    fill: "#FACC15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartiot3);
export default __webpack_public_path__ + "static/media/smartiot_3.7ee064e77d8e7879e3e2d960b23803e0.svg";
export { ForwardRef as ReactComponent };